<!--  -->
<template>
    <div>
        <Header></Header>
        <div class="preview">
            <div class="title">中小学校培育和践行社会主义核心价值观督导情况表</div>
            <div class="dudao">
                <span>督导学校____</span>
                <span>督导日期____</span>
                <span>督导人员____</span>
            </div>
            <el-table :data="tableData" style="width: 100%" border="">
                <el-table-column prop="content" align="center" label="评估内容">
                </el-table-column>
                <el-table-column prop="reason" align="center" label="评估要素" width="500">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.reason" :key="index">{{ item }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="督导扣分">
                </el-table-column>
                <el-table-column align="center" label="存在问题">
                </el-table-column>
            </el-table>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tableData: [{
                        content: '一、引领育人(16分)',
                        reason: [
                            '1、坚持育人为本、德育为先，围绕立德树人的根本任务，用社会主义核心价值观引领学校育人目标和办学思想。校长作为第一责任人，以身作则，定期组织研究培育和践行社会主义核心价值观工作，统筹领导，明确学校各管理部门、各学科责任，管理到位。（8分）',
                            '2、学校制定的发展规划和年度工作计划体现培育和践行社会主义核心价值观内容，明确长远目标，突出阶段性任务，思路清晰，举措具体，推进有力。（8分）'
                        ]
                    },
                    {
                        content: '二、融入课堂(14分)',
                        reason: [
                            '3、学校以社会主义核心价值观引领课程建设。加强《道德与法治》、《思想政治》课的教学和管理。结合学校工作实际，开发校本课程，丰富教育教学资源；加强学科间相互配合，发挥综合育人作用。（8分）',
                            '4、改进德育课程和共青团、少先队活动的内容、方式，针对性和实效性强，受学生欢迎。（6分）'
                        ]
                    },
                    {
                        content: '三、文化熏陶(14分)',
                        reason: ['5、学校用社会主义核心价值观引领文化建设。将社会主义核心价值观融入校园物质文化、精神文化和制度文化之中。（7分）',
                            '6、坚持以人为本，依法治校，完善学校制度，加强学校校风、教风、学风和班风建设，规范办学行为，营造平等和谐的文化氛围。（7分）'
                        ]
                    },
                    {
                        content: '四、实践养成(14分)',
                        reason: [
                            '7、学校将社会主义核心价值观内容融入各类实践活动之中，突出主题性和实效性，强化知行合一。有效落实“一十百千”工程相关要求，各学科平均应有不低于10%课时用于开展校内外综合实践活动。（7分）',
                            '8、学校注重行为养成教育，细化不同学段教育要求，形成养成教育的制度和机制。以“三爱”“三节”、法制教育等专题教育活动为重点，通过喜闻乐见的实践形式，引导学生形成良好行为习惯。（7分）'
                        ]
                    },
                    {
                        content: '五、为人师表(14分)',
                        reason: ['9、把社会主义核心价值观融入教师职前准入、职后培训和管理的全过程，作为教师聘任、考核和评价的首要内容。注重德育教师、班主任的配备、选拔和培养。（7分）',
                            '10、学校组织培育和践行社会主义核心价值观专题培训，将社会主义核心价值观内容作为校本研修的必修内容，计划性和实效性强。（7分）'
                        ]
                    },
                    {
                        content: '六、协同育人(9分)',
                        reason: ['11、学校建立健全协同育人机制，建立完善与社区、家庭协同育人的手段方式。（5分）',
                            '12、学校争取社区的支持和配合，协同组织社会主义核心价值观教育实践活动。（4分）'
                        ]
                    },
                ],

            }
        },
        methods: {
            objectSpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (columnIndex === 0) {
                    if (rowIndex % 2 === 0) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }

        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url("./less/view.less");
</style>